import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from './../../../redux/actions';

const mapStateToProps = (state: any) => {
  return {
    news: state.news,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      news: bindActionCreators(actions.news, dispatch),
    },
  };
};

const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'newsMain',
  })
);

export {enhance};
